<template>
  <div class="data-entry">
    <div class="switch-menu">
      <el-radio-group
        class="menu-name"
        v-for="(item, index) in menuList"
        :key="index"
        v-model="selectedTab"
        @change="toUrl(item.url)"
      >
        <el-radio-button :label="item.name"></el-radio-button>
      </el-radio-group>
    </div>
    <!-- <Index></Index> -->
    <div class="keep-alive">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
        <!-- 不缓存的视图 -->
      <router-view v-if="!$route.meta.keepAlive"></router-view>
      <template></template>
    </div>
  </div>
</template>

<script>
// import Index from '@/components/layout/router-view';
export default {
  // components: {
  //   Index
  // },
  data() {
    return {
      selectedTab: '仓库维度',
      menuList: [
        {name: '仓库维度', url: '/home/data-report/warehouseDimension'},
        {name: '客户维度', url: '/home/data-report/customerDimension'}
      ],
    }
  },

  created() {
    this.selectedTab = this.$route.meta.menuChildName
  },

  methods: {
    toUrl(v) {
      this.$router.push({
        path: v,
      });
    },
  }
};
</script>
<style lang="scss">
.data-entry {
  flex: 1;
  display: flex;
  flex-direction: column;
  .switch-menu {
    width: 100%;
    height: 48px;
    background: #fff;
    display: flex;
    justify-content: flex-start;
    padding: 0px 20px;
    box-sizing: border-box;
    border-radius: 4px 4px 0px 0px;
    border-bottom: 1px solid $baseThreeSnow;
    .menu-name {
      height: 48px;
      line-height: 46px;
      margin-right: 32px;
      .el-radio-button__inner {
        font-size: 16px;
        font-weight: bold;
        border: none;
        color: $baseGrey;
        background: transparent;
        padding: 0;
        font-family: 'PingFang SC-Regular, PingFang SC';
      }
      .is-active {
        border-bottom: 2px solid $baseBlue;
        .el-radio-button__inner {
          color: $baseBlue;
        }
      }
    }
  }
  
  .keep-alive {
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
}
</style>
